import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { OnboardingService } from 'src/app/features/onboarding/onboarding.service';
import { MixpanelEvent } from 'src/app/shared/model/mix-panel-event.enum';
import { MixpanelService } from 'src/app/shared/service/mix-panel.service';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})
export class HomepageComponent implements OnInit {
  homepage: any
  videoUrl: any
  userId: any
  mainUrl:any
  bannerButton:any
  bannerUrl:any
  bannerImage:any
  mobileBannerImage:any
  bannerText:any
  description:any
  creaticsContents:any
  eventMainHeading:any
  creaticsLists:any
  creaticsSubject:any
  buttons: any
  posterImage:any
  reloadCarousel = true;
  bannerImageUrl: any;
  cards: any

  constructor(
    private service: AdminService,
    private router: Router,
    public onboardingService: OnboardingService,
    private dialog: MatDialog,
    private meta: Meta,
    private mixpanelService:MixpanelService
    ) { }
 customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 400,
    items: 1,
    slideBy: 1,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    margin: 15,
    autoHeight: false,
    nav: false,
  }
  ngOnInit(): void {
    // this.service.getCreaticsHomepage().subscribe(data => {
    //   this.userId = data.userId;
    //   if (this.userId > 0) {
    //     this.router.navigateByUrl(`userProfiles/home/` + this.userId)
    //   }
    //   this.homepage = data.creaticsHomePage
    //   this.bannerButton = this.homepage.bannerButton
    //   this.bannerUrl = this.homepage.bannerUrl
    //   this.bannerImage = this.getFileNameFromUrl(this.homepage.bannerImage); 
    //   this.bannerText = this.homepage.bannerText
    //   this.videoUrl = this.homepage.videoUrl
    //   this.description = this.homepage.description
    //   this.eventMainHeading = this.homepage.eventMainHeading
    //   this.creaticsSubject = this.homepage.creaticsSubject
    //   this.posterImage = this.getFileNameFromUrl(this.homepage.videoThumbnail
    //   this.creaticsContents = this.homepage.creaticsContents
    //   this.creaticsLists = this.homepage.creaticsLists
    //   this.meta.updateTag({ name: 'description', content: this.description });
    //   var url = this.homepage.mainUrl

    //   if(url != null  && url !== ''){
    //     this.mainUrl=true
    //   }
    //   else{
    //     this.mainUrl = false
    //   }
    // })
    this.service.getNewCreaticsHomepage().subscribe(data =>{
      this.userId = data.userId;
        if (this.userId > 0) {
          this.router.navigateByUrl(`userProfiles/home/` + this.userId)
        }
        this.homepage = data.loggedOutHomePageDto
        this.bannerImage = this.homepage.bannerImage
        this.mobileBannerImage = this.homepage.mobileBannerImage
        this.cards = this.homepage.pageInfographicRequests
        this.bannerButton = this.homepage.buttonName
        this.bannerUrl = this.homepage.buttonUrl
        this.setBannerImage(window.innerWidth);
    })
  }
  loadVideo(){
    const myvid = document.getElementById('videoBG') as HTMLMediaElement;
    myvid.load()
  }
  setBannerImage(width: number) {
   if(width < 601){
      this.bannerImageUrl = this.mobileBannerImage
    }
    else if (width >= 601 ){
      this.bannerImageUrl = this.bannerImage
    }
  }

  getFileNameFromUrl(url: string): string {
    const filename = url.split('amazonaws.com/')[1];
    return 'https://dmle451e1wlcf.cloudfront.net/'+filename
  }
  lastScreenType: 'mobile' | 'desktop' | null = null;

  refreshCarousel() {
      this.reloadCarousel = false;
      setTimeout(() => {
        this.reloadCarousel = true;
      },300);
    }
    
    previousWidth: number = window.innerWidth;
    resizeTimeout: any;
    
    @HostListener('window:resize', ['$event'])
    checkScreenSize(event: any) {
      clearTimeout(this.resizeTimeout);
    
      this.resizeTimeout = setTimeout(() => {
        const currentWidth = window.innerWidth;
    
        if (Math.abs(currentWidth - this.previousWidth) < 20) return;
    
        if (currentWidth <= 1000) {
          this.refreshCarousel();
        }
    
        this.previousWidth = currentWidth;
      }, 300);
    }
    
    openDialog(templateRef) {
      let dialogRef = this.dialog.open(templateRef);      
    }

    redirect(link:any){
      window.location.href = `${link}`
    }
    onPlay(){
      this.mixpanelService.trackEvent({
        event:MixpanelEvent.BUTTON_CLICKED,
        properties:{
          title:"home_page_video_played",
          feature_context: 'HOME'
        }
      })
    }
    buttonAction(){
      window.location.href = this.bannerUrl
    }
}
